import { z } from 'zod';
import { zPushNotificationPermissionStatus } from './enums';

export const pushNotificationConfigSchema = z.object({
  expoPushToken: z.string().nullable().default(null),
  notificationPermissionStatus: zPushNotificationPermissionStatus,

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type PushNotificationConfig = z.output<typeof pushNotificationConfigSchema>;

export const pushNotificationConfigStrictSchema = pushNotificationConfigSchema;

export const pushNotificationConfigCvxSchema = pushNotificationConfigSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type PushNotificationConfigCvx = z.output<typeof pushNotificationConfigCvxSchema>;
